import { gql } from '@apollo/client';

export const listUsers = gql`
  query listUsers($pagination: PaginationInput, $filter: UserFilter) {
    listUsers(pagination: $pagination, filter: $filter) {
      ... on User {
        email
        id
        name
      }
      ... on Invitation {
        email
        id
        name
        organization {
          name
        }
        invitedBy {
          name
        }
        source
      }
    }
  }
`;

export const getUser = gql`
  query getUser($id: ID!) {
    getUser(id: $id) {
      id
      cognito {
        enabled
        status
      }
      invitations {
        invitedDate
        organization {
          id
          name
          hasActiveScimClient
        }
        role
        status
      }
      memberships {
        role
        organization {
          id
          name
          hasActiveScimClient
          subscription {
            id
            expirationDate
            validFrom
            product {
              name {
                value
                languageId
                languageCode
              }
            }
          }
        }
      }
      subscriptions {
        id
        expirationDate
        validFrom
        product {
          name {
            value
            languageId
            languageCode
          }
        }
      }
    }
  }
`;

export const listOrganizations = gql`
  query listOrganizations($pagination: PaginationInput) {
    listOrganizations(pagination: $pagination) {
      id
      name
      hasActiveScimClient
    }
  }
`;
